"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newLine = void 0;
/**
 * Create a new line layout, which is a line between two points.
 */
function newLine(startPoint, endPoint) {
    return {
        start: startPoint,
        end: endPoint,
        type: 'LINE',
    };
}
exports.newLine = newLine;
//# sourceMappingURL=line.js.map